import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsCard = ({ title, value, subtitle, icon, trend, trendValue }) => {
  const getTrendColor = (trend) => {
    if (trend === 'up') return 'text-success';
    if (trend === 'down') return 'text-destructive';
    return 'text-muted-foreground';
  };

  const getTrendIcon = (trend) => {
    if (trend === 'up') return 'TrendingUp';
    if (trend === 'down') return 'TrendingDown';
    return 'Minus';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-sm">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg">
            <Icon name={icon} size={20} className="text-primary" />
          </div>
          <h3 className="font-heading font-semibold text-sm text-muted-foreground uppercase tracking-wide">
            {title}
          </h3>
        </div>
        {trend && (
          <div className={`flex items-center space-x-1 ${getTrendColor(trend)}`}>
            <Icon name={getTrendIcon(trend)} size={16} />
            <span className="font-body font-medium text-sm">{trendValue}</span>
          </div>
        )}
      </div>
      
      <div className="space-y-1">
        <div className="font-heading font-bold text-3xl text-foreground">
          {value}
        </div>
        {subtitle && (
          <p className="font-body text-sm text-muted-foreground">
            {subtitle}
          </p>
        )}
      </div>
    </div>
  );
};

export default MetricsCard;